export { default } from './ConfirmModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/ConfirmModal/index.js